export interface StoryblokImageOptions {
  width?: number
  height?: number
  focus?: string | null
  format?: 'webp' | 'jpeg' | 'png' | 'auto'
  quality?: number
}

/**
 * Builds a Storyblok image URL with on-the-fly transformations so Next.js can
 * fetch, cache, and optimize the transformed asset.
 */
export function buildStoryblokImageUrl(
  filename: string,
  options: StoryblokImageOptions = {},
): string {
  if (!filename) {
    return ''
  }

  const { width = 1200, height = 0, focus, format, quality } = options

  let url = filename

  // replace with custom assets domains
  url = url.replace('https://a.storyblok.com/f/328257', 'https://assets.vendure.io')

  // Base resize/crop operation. Height "0" keeps aspect ratio.
  url += `/m/${Math.max(0, width)}x${Math.max(0, height)}`

  const filters: string[] = []
  if (focus && focus !== '') {
    filters.push(`focal(${focus})`)
  }
  if (format) {
    filters.push(`format(${format})`)
  }
  if (quality) {
    filters.push(`quality(${quality})`)
  }

  if (filters.length) {
    url += `/filters:${filters.join(':')}`
  }

  return url
}
